import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../store/auth';
import { Panel, Empty } from '../ui';

/** Route-level permission check. The server enforces every call; this only hides what a user cannot use. */
export function Guard({ any, children }: { any: string[]; children: ReactNode }) {
  const can = useAuth((s) => s.can);
  if (any.length && !can(...any)) return <NoAccess />;
  return <>{children}</>;
}

export function NoAccess() {
  return (
    <Panel>
      <Empty title="No access">
        <>Your role cannot open this page. Ask the Finance Admin if you need it.</>
      </Empty>
      <div className="empty" style={{ paddingTop: 0 }}>
        <Link className="btn" to="/dashboard">
          Back to dashboard
        </Link>
      </div>
    </Panel>
  );
}

export function NotFound() {
  return (
    <Panel>
      <Empty title="Page not found">
        <>That page does not exist, or the link is old.</>
      </Empty>
      <div className="empty" style={{ paddingTop: 0 }}>
        <Link className="btn" to="/dashboard">
          Back to dashboard
        </Link>
      </div>
    </Panel>
  );
}
